<template>
    <div class="business">
        <menuBox :step="3"></menuBox>
        <div class="about-title">關於我們</div>
        <div class="business-text">
            <p>FLEUSWORD，2023年成立於香港，是一家國際性綜合性網絡企業，是香港網絡科技行業的後起之秀。我公司致力於通過優質的網絡、服務、技術和平台，幫助企業客戶拓展全球業務，為客戶全球品牌戰略提供綜合解決方案。 FLEUSWORD的核心競爭力在於以技術和數據驅動，提供包括應用開發、數據分析、業務運營在內的一站式海外移動應用服務。利用大數據和可視化技術，可以對複雜的用戶行為和業務數據進行可視化分析，為客戶提供精準、個性化的運營決策支持，從而提升綜合競爭力。 </p>
            <p>我們公司始終堅持科技創新的核心地位，肩負各界期望，幫助更多的出海企業，按規劃實施海外流量+saas服務+支付服務等服務體系，助推出海企業高效增能，全力服務本土化經濟，力爭成為運營規範、特色鮮明、監管放心、用戶信賴的精品科技公司。在深入考察和研究下，目前，依托此前建立的市場渠道，公司由騰訊百度等知名it企業前員工組成核心團隊 ，隨著服務體系和研發體系的完善，開發更多高科技出海企業的特色投放平台，加速科技成果向現實生產力轉化！ </p>
        </div>        

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs(){
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>
<style lang="less" scoped>
.about-title {
    background-image: url(../assets/about-1.png);
    width: 100%;
    height: 320px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    font-weight: 500;
    color: #333333;
}

.business-text {
    padding: 80px 360px 120px 360px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;

    p {
        text-indent: 2em;
        margin-top: 28px;
    }
}

</style>
